function normalizeColorName(value) {
  return String(value || "")
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]/g, "");
}

function getProductSlides() {
  return Array.from(
    document.querySelectorAll(".swiper-main .swiper-slide:not(.swiper-slide-duplicate)")
  );
}

function getImageFileToken(src) {
  if (!src) return "";

  const path = src.split("/files/")[1] || src.split("/products/")[1] || "";
  return path.split("?")[0].split("/").pop().split("_")[0].split(".")[0];
}

function setActiveProductThumb(index) {
  document.querySelectorAll(".product-thumb").forEach((thumb, thumbIndex) => {
    thumb.classList.toggle("is-active", thumbIndex === index);
  });

  const thumbsSwiper = document.querySelector(".swiper-thumbs")?.swiper;
  if (thumbsSwiper && index >= 0) {
    thumbsSwiper.slideTo(index);
  }
}

function slideMainGalleryToIndex(index) {
  const swiperEl = document.querySelector(".swiper-main");
  const swiper = swiperEl?.swiper;
  if (!swiper || index < 0) return;

  if (swiper.params.loop) {
    swiper.slideToLoop(index);
  } else {
    swiper.slideTo(index);
  }

  setActiveProductThumb(index);
}

function findSlideIndexForVariant(variant) {
  if (!variant) return -1;

  const slides = getProductSlides();
  const featuredMediaId = variant.featured_media?.id;

  if (featuredMediaId) {
    const mediaIndex = slides.findIndex(
      (slide) => String(slide.dataset.mediaId) === String(featuredMediaId)
    );
    if (mediaIndex >= 0) return mediaIndex;
  }

  const imageSrc = variant.featured_image?.src || variant.featured_media?.preview_image?.src;
  if (imageSrc) {
    const filename = (
      imageSrc.split("/files/")[1] || imageSrc.split("/products/")[1] || ""
    )
      .split("?")[0]
      .toLowerCase();

    if (filename) {
      const filenameIndex = slides.findIndex((slide) => {
        const img = slide.querySelector("img");
        return img && img.src.toLowerCase().includes(filename);
      });
      if (filenameIndex >= 0) return filenameIndex;
    }
  }

  const colorName = variant.option1 || variant.public_title || variant.title?.split(" - ")?.pop();
  const normalizedColor = normalizeColorName(colorName);
  if (!normalizedColor) return -1;

  return slides.findIndex((slide) => {
    const img = slide.querySelector("img");
    if (!img) return false;

    const fileToken = normalizeColorName(getImageFileToken(img.src));
    return fileToken === normalizedColor;
  });
}

function slideMainGalleryToVariant(variant) {
  slideMainGalleryToIndex(findSlideIndexForVariant(variant));
}

function syncVariantFromSlideIndex(index) {
  const slide = getProductSlides()[index];
  const img = slide?.querySelector("img");
  if (!img) return;

  const fileToken = normalizeColorName(getImageFileToken(img.src));
  if (!fileToken) return;

  const matchingRadio = Array.from(
    document.querySelectorAll('fieldset.product-form__input--pill input[type="radio"]')
  ).find((radio) => normalizeColorName(radio.value) === fileToken);

  if (matchingRadio && !matchingRadio.checked) {
    matchingRadio.checked = true;
    matchingRadio.dispatchEvent(new Event("change", { bubbles: true }));
  }
}

function initProductGallery() {
  const swiperEl = document.querySelector(".swiper-main");
  if (!swiperEl) return;

  const thumbsSwiperEl = document.querySelector(".swiper-thumbs");
  if (thumbsSwiperEl) {
    const thumbsWrap = thumbsSwiperEl.closest(".product-images-thumbs-wrap");

    new Swiper(thumbsSwiperEl, {
      spaceBetween: 6,
      watchOverflow: true,
      navigation: {
        nextEl: thumbsWrap?.querySelector(".product-thumbs-nav--next"),
        prevEl: thumbsWrap?.querySelector(".product-thumbs-nav--prev"),
      },
      breakpoints: {
        0: {
          direction: "horizontal",
          slidesPerView: "auto",
        },
        1024: {
          direction: "vertical",
          slidesPerView: 7,
        },
      },
    });
  }

  const mainSwiper = new Swiper(swiperEl, {
    slidesPerView: 1,
    spaceBetween: 10,
    loop: getProductSlides().length > 1,
    autoHeight: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
  });

  mainSwiper.on("slideChange", () => {
    setActiveProductThumb(mainSwiper.realIndex);
  });

  document.querySelectorAll(".product-thumb").forEach((thumb) => {
    thumb.addEventListener("click", function () {
      const index = Number(thumb.dataset.index);
      if (Number.isNaN(index)) return;

      slideMainGalleryToIndex(index);
      syncVariantFromSlideIndex(index);
    });
  });

  const selectedVariantNode = document.querySelector("variant-selects [data-selected-variant]");
  if (selectedVariantNode?.textContent) {
    try {
      slideMainGalleryToVariant(JSON.parse(selectedVariantNode.textContent));
    } catch (error) {
      setActiveProductThumb(mainSwiper.realIndex);
    }
  } else {
    setActiveProductThumb(mainSwiper.realIndex);
  }
}

function initProductVariantGallerySync() {
  if (!window.location.pathname.includes("/products/")) return;
  if (typeof subscribe !== "function" || typeof PUB_SUB_EVENTS === "undefined") return;

  subscribe(PUB_SUB_EVENTS.variantChange, ({ data: { variant } }) => {
    slideMainGalleryToVariant(variant);
  });
}

document.addEventListener("DOMContentLoaded", function () {
  // Set up Shopify routes if they don't exist
  if (!window.Shopify) {
    window.Shopify = {};
  }

  if (!window.Shopify.routes) {
    window.Shopify.routes = {
      root: "/",
    };
  }

  initProductVariantGallerySync();
  initProductGallery();

  document
    .querySelectorAll("product-recommendations")
    .forEach((recommendationSection) => {
      const observer = new MutationObserver((mutations, obs) => {
        if (recommendationSection.querySelector(".related-produts-swiper")) {
          // Swiper DOM has loaded, safe to initialize
          initRecommendationSwiper(recommendationSection);
          obs.disconnect(); // Stop observing
        }
      });

      observer.observe(recommendationSection, {
        childList: true,
        subtree: true,
      });
    });

  function initRecommendationSwiper(container) {
    const swiperrecommand = container.querySelector(".related-produts-swiper");
    if (!swiperrecommand) return;

    new Swiper(swiperrecommand, {
      loop: false,
      spaceBetween: 4,
      slidesPerView: 3,
      navigation: {
        nextEl: swiperrecommand.querySelector(".swiper-button-next"),
        prevEl: swiperrecommand.querySelector(".swiper-button-prev"),
      },
      breakpoints: {
        1024: {
          slidesPerView: 4,
          spaceBetween: 5,
        },
        1280: {
          slidesPerView: 6,
          spaceBetween: 10,
        },
      },
    });
  }

  document.querySelectorAll(".coll-swiper").forEach((swiperEl, index) => {
    new Swiper(swiperEl, {
      loop: false,
      centeredSlides: false,
      slidesPerView: 2.5,
      spaceBetween: 7,
      navigation: {
        nextEl: swiperEl.querySelector(".swiper-button-next"),
        prevEl: swiperEl.querySelector(".swiper-button-prev"),
      },
      pagination: {
        el: swiperEl.querySelector(".swiper-pagination"),
        clickable: true,
      },
      breakpoints: {
        768: {
          slidesPerView: 3.5,
          spaceBetween: 7,
        },
        1024: {
          slidesPerView: 4.5,
          spaceBetween: 7,
        },
        1280: {
          slidesPerView: 6,
          spaceBetween: 7,
        },
      },
    });
  });
  document.querySelectorAll(".product-images-swiper").forEach((swiperEl) => {
    new Swiper(swiperEl, {
      slidesPerView: 1,
      spaceBetween: 10,
      loop: true,
      initialSlide: 1,
      navigation: {
        nextEl: swiperEl.querySelector(".swiper-button-next"),
        prevEl: swiperEl.querySelector(".swiper-button-prev"),
      },
      pagination: {
        el: swiperEl.querySelector(".swiper-pagination"),
        clickable: true,
      },
    });
  });
  document.addEventListener("click", async (e) => {
    const btn = e.target.closest(".js-variant-btn");
    if (!btn) return;

    e.preventDefault();
    btn.classList.add("loading");

    try {
      const variantId = btn.dataset.variantId;

      // Add to cart
      await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
      });

      // Get updated cart data
      const cart = await fetch("/cart.js").then((res) => res.json());

      // Update desktop count
      const desktopCartCount = document.querySelector(
        ".cart-count-bubble .count-cart-item"
      );
      if (desktopCartCount) {
        desktopCartCount.textContent = `(${cart.item_count})`;
      }

      // Update mobile count
      const mobileCartCount = document.querySelector(".cart-item-count");
      if (mobileCartCount) {
        mobileCartCount.textContent = cart.item_count;
      }

      // Load and inject cart drawer content
      const html = await fetch("/?sections=cart-drawer").then((res) =>
        res.json()
      );
      const drawer = document.querySelector("cart-drawer");
      if (!drawer) return;

      drawer.classList.remove("is-empty");

      const temp = document.createElement("div");
      temp.innerHTML = html["cart-drawer"];

      const newInner = temp.querySelector(".drawer__inner");
      const currentInner = drawer.querySelector(".drawer__inner");

      if (newInner && currentInner) {
        currentInner.innerHTML = newInner.innerHTML;

        // Re-init drawer if needed
        drawer.initialize?.();
        drawer.bindEvents?.();

        // Open drawer
        setTimeout(() => {
          drawer.classList.add("animate", "active");
          document.body.classList.add("overflow-hidden");
          drawer
            .querySelector(".drawer")
            ?.style.setProperty("visibility", "visible");
        }, 100);
      }
    } catch (err) {
      console.error("Cart update failed:", err);
    } finally {
      btn.classList.remove("loading");
    }
  });

  document.querySelectorAll(".product-form-quick-add").forEach((form) => {
    form.addEventListener("submit", function (e) {
      e.preventDefault();

      const formData = new FormData(form);
      const variantId = form.querySelector('input[name="id"]')?.value;

      if (!variantId) {
        console.error("No variant ID found");
        return;
      }

      // Show loading state if there's a submit button
      const submitBtn = form.querySelector('button[type="submit"]');
      if (submitBtn) submitBtn.classList.add("loading");

      // Add to cart
      const jsonData = {
        items: [
          {
            id: variantId,
            quantity: parseInt(formData.get("quantity") || 1),
          },
        ],
      };

      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(jsonData),
      })
        .then((response) => response.json())
        .then((data) => {
          // Dispatch cart:added event
          document.documentElement.dispatchEvent(
            new CustomEvent("variant:added", {
              bubbles: true,
              detail: {
                variant: data.items[0],
                quantity: jsonData.items[0].quantity,
              },
            })
          );

          // Get cart state
          return fetch("/cart.js");
        })
        .then((response) => response.json())
        .then((cart) => {
          // Update cart count if needed
          if (window.updateCartCount) {
            window.updateCartCount(cart.item_count);
          }

          // Get cart drawer content
          return fetch("/?sections=cart-drawer");
        })
        .then((response) => response.json())
        .then((sections) => {
          if (sections["cart-drawer"]) {
            const drawer = document.querySelector("cart-drawer");
            if (!drawer) {
              console.error("Cart drawer element not found");
              return;
            }

            // Remove empty state if it exists
            drawer.classList.remove("is-empty");

            // Parse the new content
            const tempDiv = document.createElement("div");
            tempDiv.innerHTML = sections["cart-drawer"];

            // Get the drawer inner content
            const newDrawerInner = tempDiv.querySelector(".drawer__inner");
            const currentDrawerInner = drawer.querySelector(".drawer__inner");

            if (newDrawerInner && currentDrawerInner) {
              // Update the drawer content
              currentDrawerInner.innerHTML = newDrawerInner.innerHTML;

              // Initialize any required components
              if (typeof drawer.initialize === "function") {
                drawer.initialize();
              }

              // Bind events
              if (typeof drawer.bindEvents === "function") {
                drawer.bindEvents();
              }

              // Show the drawer
              setTimeout(() => {
                drawer.classList.add("animate", "active");
                document.body.classList.add("overflow-hidden");

                // Remove visibility: hidden
                const drawerElement = drawer.querySelector(".drawer");
                if (drawerElement) {
                  drawerElement.style.visibility = "visible";
                }
              }, 100);
            }
          }
        })
        .catch((error) => {
          console.error("Error:", error);
        })
        .finally(() => {
          if (submitBtn) {
            setTimeout(() => {
              submitBtn.classList.remove("loading");
            }, 1000);
          }
        });
    });
  });
  const menuSwiper = document.querySelector(".header-menu-swiper");
  const menuList = document.querySelector(".header-outer-section");

  if (menuSwiper && menuList) {
    function checkScroll() {
      console.log("scrollWidth:", menuList.scrollWidth);
      console.log("clientWidth:", menuList.clientWidth);

      if (menuList.scrollWidth > menuList.clientWidth) {
        menuSwiper.classList.add("scrolling");
        console.log("Scrolling: YES");
      } else {
        menuSwiper.classList.remove("scrolling");
        console.log("Scrolling: NO");
      }
    }

    // Delay in case content loads slowly
    setTimeout(checkScroll, 100);

    // Re-check on resize
    window.addEventListener("resize", checkScroll);
  } else {
    console.warn("Menu elements not found");
  }
});

$(document).ready(function () {
  $(".footer-block-wrap").on("click", function () {
    const $parent = $(this).closest(".footer-block");

    // Toggle is-active class
    $parent.toggleClass("is-active");

    // Toggle plus/minus icons
    const $plusIcon = $(this).find(".menu-icon-plus");
    const $minusIcon = $(this).find(".menu-icon-minus");

    if ($parent.hasClass("is-active")) {
      $plusIcon.hide();
      $minusIcon.show();
    } else {
      $plusIcon.show();
      $minusIcon.hide();
    }
  });

  $(document).on(
    "click",
    ".menu-drawer__navigation .mobile-search",
    function (e) {
      e.preventDefault();

      console.log("Mobile search clicked"); // Debug log

      // Trigger the click on search-wrapper
      $("body .header__icons .search-wrapper").trigger("click");
    }
  );
});
